import React from 'react'
import { useMutation } from '@apollo/client'
import { Button } from 'semantic-ui-react'
import { MARK_AS_PAID } from '../../../../graphql/job'

const MarkAsPaidButton = ({ job }) => {
    const [updateJob, { loading }] = useMutation(MARK_AS_PAID)
    const markAsPaid = () => {
        const confirm = window.confirm(
            `
            Are you sure you want to mark this job as "Paid"?
            Please make sure you've paid this expert.
            `
        )
        if (confirm) {
            updateJob({
                variables: {
                    userId: job.user.id,
                    projectId: job.project.id,
                    job: {
                        overall_status: 'Paid',
                        completedAt: new Date(),
                    },
                },
            })
        }
    }
    if (
        !['Pending Scheduling', 'Scheduled', 'Completed', 'Paid'].includes(
            job.overall_status
        )
    ) {
        return null
    }
    const isPaid = job.overall_status === 'Paid'
    return (
        <>
            <Button
                color={isPaid ? 'black' : 'red'}
                basic
                size="mini"
                floated="right"
                loading={loading}
                disabled={loading || isPaid}
                onClick={markAsPaid}
            >
                {isPaid ? 'Completed and Paid' : 'Mark as Paid'}
            </Button>
        </>
    )
}

export default MarkAsPaidButton
